import Flex from 'antd/lib/flex'
import styles from './Banner.module.less'
import { ReactNode } from 'react'
import InfoCircleFilled from '@ant-design/icons/lib/icons/InfoCircleFilled'

type BannerPropsType = {
    message: string
    icon?: ReactNode
}

export const Banner = (props: BannerPropsType) => {
    return (
        <Flex className={styles.bannerContainer} gap={8}>
            <div className={styles.icon}>{props.icon ?? <InfoCircleFilled />}</div>
            <div className={styles.message}>{props.message}</div>
        </Flex>
    )
}
